import { ChoiceList } from "@cmsgov/ds-medicare-gov";
import React, { useContext, ChangeEvent } from "react";
import {
  BooleanMapArray,
  PlanType,
  ActionType,
  BooleanMap,
} from "../../@types";
import { CONSTANTS as C, TealiumConversions } from "../../helpers/CONSTANTS";
import {
  isMedicareAdvantageType,
  useTranslate,
  sendTealiumEvent,
} from "../../helpers";
import { AppStore } from "../../app/store";
import { defaultState } from "../../app/store/AppStore";

export interface CoverageFilterGroupProps {
  onFilterUpdate: (filters: BooleanMapArray) => void;
}

const CoverageFilterGroup: React.FunctionComponent<CoverageFilterGroupProps> = props => {
  const {
    state: {
      planType,
      searchResultsFilters = defaultState.searchResultsFilters,
    },
    dispatch,
  } = useContext(AppStore.AppContext);
  const { filters } = searchResultsFilters;
  const t = useTranslate();

  const handleChecking = (event: ChangeEvent<HTMLInputElement>): void => {
    const { checked, value } = event.currentTarget;
    const newFilters = { ...filters, [value]: checked };

    // Get and send Tealium values
    if (checked && value in TealiumConversions) {
      sendTealiumEvent(
        "Find Plans - Available Plans",
        TealiumConversions[value]
      );
    }

    const filtersToSend = Object.entries(newFilters).filter(([_, val]) => val);
    const selectedFilters = filtersToSend.reduce(
      (selections, [filter, selected]) => {
        selections[filter] = selected;

        return selections;
      },
      {} as BooleanMap
    );

    dispatch({
      type: ActionType.UPDATE_SEARCH_RESULTS_FILTERS,
      payload: {
        ...searchResultsFilters,
        filters: selectedFilters,
      },
    });

    props.onFilterUpdate(filtersToSend);
  };

  return (
    <div>
      {planType && (
        <ChoiceList
          name="CoverageFilter"
          type="checkbox"
          label={
            <span className="PlanFilters__filterGroupHeadingName">
              {isMedicareAdvantageType(planType || PlanType.MAPD)
                ? t("search_results_page.filters.plan_with_these_benefits")
                : t("app.terms.drug_coverage_options")}
            </span>
          }
          className="PlanFilters__filterGroupHeading ds-u-margin--0"
          onChange={handleChecking}
          choices={Object.entries(C.filtersByPlan[planType]).map(
            ([filterKey, filterName]) => {
              return {
                checked: !!filters[filterName],
                label: t(C.filterLabels[filterKey]),
                value: filterName,
              };
            }
          )}
        />
      )}
    </div>
  );
};

export default CoverageFilterGroup;
